const apiUrl = process.env.REACT_APP_API_URL;

export const GetSprintStatus = async (idProjecte: string, numero: number, userTipo: string) => {
    try {
        const response = await fetch(
            `${apiUrl}:8061/projectes/${idProjecte}/sprints/${numero}/status?userTipo=${userTipo}`
        );
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener el estado del sprint:', error);
        return null;
    }
};
